// extracted by mini-css-extract-plugin
export default {"imageWrapper":"YH-z","twoColumnImage":"ZH-z"};